module.exports = __webpack_public_path__ + "static/island-of-the-day-before-8942b9ca082493598e3843e610f16e68.jpg";